<template lang="pug">
div.empty-cell
    div.empty-cell(v-if='times.length === 0')
        button.sharp.button.is-small.is-fullwidth.is-light.empty-cell(@click='new_time')
            font-awesome-icon(icon="plus")
    div(v-else)
        TimeEntry(v-for='time in times', :time='time')
        .flex
            .flex-grow: button.sharp.button.is-small.is-fullwidth.is-info(@click='new_time')
                font-awesome-icon(icon="plus")
</template>

<script>
import moment from "moment";
import TimeEntry from "@/components/TimeEntry";
export default {
  name: "TaskCell",
  components: {
    TimeEntry
  },
  computed: {
    times() {
      return this.$store.getters.cell_times(this.day, this.task);
    }
  },
  props: ["task", "day"],
  mounted: function() {},
  methods: {
    new_time() {
      // Create a new time, based on the task and day
      this.$store.state.bus.$emit("edit-time", {
        day: this.day,
        task: this.task
      });
    }
  }
};
</script>

<style scoped lang="less">
.sharp {
  border-radius: 0px !important;
}
.empty-cell {
  height: 100% !important;
}
</style>
